import BgImage from '../../assets/personal-loan/personal-loan-bg.png'
import { Box, Typography } from '@mui/material'
import SMQuickCash from '../../containers/PersonalLoan/QuickCash'
import SMWhyChoose from '../../containers/PersonalLoan/WhyChoose'
import SMRequirements from '../../containers/PersonalLoan/Requirements'
import SMHowWork from '../../containers/PersonalLoan/HowWork'
import SMPLInstructionVideo from '../../containers/PersonalLoan/InstructionVideo'
import SMLicense from '../../containers/PersonalLoan/License'
import SMDownload from '../../containers/PersonalLoan/Download'
import FAQItem from '../../components/ui/FAQ'
import axios from 'axios'
import { FAQUrl } from '../../common/url'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { App_Language_key } from '../../common/config'

export const PersonalLoanScreen: React.FC = () => {

    const { t } = useTranslation()

    const [data, setData] = useState(null)

    useEffect(() => {
        (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async () => {
        try {
            var url = FAQUrl + '?publicationState=live&sort=sequence:ASC&filters[language][$eq]=' + language + '&filters[category][$eq]=Personal Loan'
            const response = await axios.get(url)
            if (response.status === 200) {
                setData(response.data['data'])
            }
        } catch (error) {
            console.error(error)
        }
    }

    const renderFaqAccordion = () => (
        <Box sx={{
            width: '100%',
            paddingLeft: '72px',
            paddingRight: '72px',
            paddingTop: '60px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#FFFFFF'
        }}>
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'} paddingBottom={'40px'}>
                {t('t164')}
            </Typography>
            <FAQItem data={data}></FAQItem>
        </Box>
    )
    // ======================= VIEWS
    return (
        <>
        <Box sx={{ position: 'relative', 
                objectFit: 'cover',
                backgroundImage: `url(${BgImage})`,                
                backgroundSize: 'cover',    
                backgroundPosition: 'top',
                width: '100%',
                height: '457px',
        }}>

          <Box sx={{ position: 'absolute', left: 0, top: 0, right: 0, bottom: 0, justifyContent: 'center', alignContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={50} fontWeight={600} color={'#FBBF23'} textAlign={'center'}>
                  {t('t205')}
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', alignItems: 'center', paddingTop: '16px' }}>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t206')}
                  </Typography>
                  <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t207')}
                  </Typography>
                  <Box sx={{ width: '1px', height: '20px', backgroundColor: '#FFFFFF', marginLeft: '20px', marginRight: '20px' }}></Box>
                  <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t208')}
                  </Typography>
              </Box>
          </Box>
      </Box>


            <SMQuickCash />
            <SMWhyChoose />
            <SMRequirements />
            <SMHowWork />
            <SMPLInstructionVideo />
            <SMLicense />
            {renderFaqAccordion()}
            <SMDownload />
        </>
    )
}

// ======================= EXPORT
export default PersonalLoanScreen
